module.exports = __webpack_public_path__ + "static/media/matera.59dd5e2a.svg";